/* Tapsara — cart drawer empty-state class sync. 13 Oct 2026.

   THE BUG, as a customer hit it. Open the cart while it is empty, add a
   product from "You might also like", and the drawer still looks empty — no
   line item, no total, no checkout button. Reload, or add anything from a
   product page, and both items appear at once, so it reads as if the first
   add was lost and then came back.

   Nothing was lost. Measured 13 Oct on a fresh page with an empty cart:

     picker opens              true
     server cart after add     2 items   (the product + the free gift)
     items present in the DOM  2
     <cart-drawer> class       "mini-cart drawer is-empty"   <-- stale

   The add worked and the markup was correct. The drawer was hiding it.

   WHY. snippets/cart-drawer.liquid puts the state on the OUTER element:

     <cart-drawer class="mini-cart drawer{% if cart == empty %} is-empty{% endif %}">
       <div id="CartDrawer"> ... </div>
     </cart-drawer>

   but every refresh path — the theme's own renderContents, the gift script,
   the gift guard, and the picker here — replaces only #CartDrawer.innerHTML.
   The class sits one level ABOVE that, so it is never updated, and the
   theme's CSS keeps hiding what is now there. Measured with the class on:

     .product-cart-items   display:none   height 0   (was flex, 306px)
     .footer-mini-cart     display:none   height 0   (was block, 162px)

   The checkout button is inside that footer, so the customer could not check
   out either.

   THE FIX, at the bottom of this file. One observer reads the truth from the
   markup — are there any .cart-item nodes — and puts the class in or out
   accordingly, whoever did the re-render. It restores the theme's own class
   rather than overriding the theme's CSS, so nothing here has to know which
   properties that CSS sets.

   16 Sep 2026, cart folded in 21 Sep.

   The <script> blocks from snippets/tapsara-footer-accordion, tapsara-cards,
   tapsara-category-row and tapsara-solution-area, in render order, plus the
   reviews-carousel gutter sync, the SEO block toggle, the free gift guard,
   the cart drawer and the drawer's upsell slider. Each is an IIFE, so they
   share no scope.

   Loaded with defer from snippets/tapsara-core.liquid.

   TRIED AND REVERTED, 23 Sep 2026 — do not attempt again from here.
   The closed cart drawer downloads 30 upsell images (1,424 KB, 32% of all
   image bytes) on every page of the site. A block was added here to park
   their src in a data attribute and put it back when the drawer opened. It
   cannot work: measured on the home page, the first of those images starts
   downloading at 981ms and the DOM is not interactive until 1580ms — the
   browser's preload scanner reads the src straight out of the HTML long
   before any deferred script runs. Removing the attribute afterwards just
   cancels nothing. That weight has to be fixed where the HTML is written:
   the product count in Theme settings > Cart, or by not printing the cards
   into every page at all. See snippets/cart-drawer.liquid.

   DO NOT hand-edit. See the header of assets/tapsara.css.
   Previous versions: assets/tapsara-backup-20260921.js (pre-gift-guard),
   assets/tapsara-backup-20260921b.js (pre-cart-fold).
*/
/* tapsara-footer-accordion */
(function () {
'use strict';
var CHEVRON =
'<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"' +
' stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"' +
' stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
function moveSocial(footer) {
var social = footer.querySelector('ul.social-icon');
var signup = footer.querySelector('.email-signup-block');
if (!social || !signup) return;
var target = signup.parentElement;
if (!target || social.parentElement === target) return;
target.appendChild(social);
social.classList.add('tps-ft-social');
}
function build() {
var footer = document.querySelector('[id*="__footer"]');
if (!footer) return;
if (footer.querySelector('.tps-ft-acc')) return;
moveSocial(footer);
var heads = footer.querySelectorAll(
'.text-block h1, .text-block h2, .text-block h3,' +
'.text-block h4, .text-block h5, .text-block h6'
);
for (var i = 0; i < heads.length; i++) {
var headBlock = heads[i].parentElement;
var col = headBlock && headBlock.parentElement;
if (!col || col.querySelector('.accordian-btn')) continue;
var hasContent = false;
var node = headBlock.nextElementSibling;
while (node) {
if (node.tagName !== 'STYLE') { hasContent = true; break; }
node = node.nextElementSibling;
}
if (!hasContent) continue;
wrap(heads[i], headBlock, col);
return;
}
}
function wrap(heading, headBlock, col) {
var label = (heading.textContent || '').trim();
if (!label) return;
col.classList.add('tps-ft-acc');
headBlock.classList.add('tps-ft-acc-head');
var content = document.createElement('div');
content.className = 'tps-ft-acc-content';
content.id = 'tps-ft-acc-panel';
while (headBlock.nextSibling) content.appendChild(headBlock.nextSibling);
col.appendChild(content);
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'ft-title tps-ft-acc-btn';
btn.setAttribute('aria-expanded', 'false');
btn.setAttribute('aria-controls', content.id);
btn.innerHTML = '<p><strong></strong></p>' + CHEVRON;
btn.querySelector('strong').textContent = label;
col.insertBefore(btn, headBlock);
btn.addEventListener('click', function () {
var open = !btn.classList.contains('show');
btn.classList.toggle('show', open);
content.classList.toggle('show', open);
btn.setAttribute('aria-expanded', open ? 'true' : 'false');
content.style.height = open ? content.scrollHeight + 'px' : '0px';
});
var wide = window.matchMedia('(min-width: 601px)');
var onChange = function (e) {
if (!e.matches) return;
content.style.height = '';
content.classList.remove('show');
btn.classList.remove('show');
btn.setAttribute('aria-expanded', 'false');
};
if (wide.addEventListener) wide.addEventListener('change', onChange);
else if (wide.addListener) wide.addListener(onChange);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', build);
} else {
build();
}
})();
/* tapsara-cards */
(function () {
function rebuildRating(card) {
var rw = card.querySelector('.rating-wrapper');
if (!rw) {
var ph = document.createElement('div');
ph.className = 'rating-wrapper';
var t = card.querySelector('.card-title');
if (t && t.parentNode) t.parentNode.insertBefore(ph, t.nextSibling);
return;
}
if (rw.querySelector('.tps-rating')) return;
var rc = rw.querySelector('.rating-count');
if (!rc) return;
var m = (rc.textContent || '').replace(/\s+/g, ' ')
.match(/([0-9.]+)\s*\|\s*([0-9]+)\s*review/i);
if (!m) return;
var score = parseFloat(m[1]);
var n = parseInt(m[2], 10);
var on = Math.round(score);
var stars = '';
for (var i = 1; i <= 5; i++) {
stars += '<span class="tps-star' + (i <= on ? ' is-on' : '') + '">★</span>';
}
rw.innerHTML =
'<span class="tps-rating">' +
'<span class="tps-rating__stars" aria-hidden="true">' + stars + '</span>' +
'<span class="tps-rating__score">' + score.toFixed(1) + '</span>' +
'<span class="tps-rating__count">' + n + ' review' + (n === 1 ? '' : 's') + '</span>' +
'</span>';
}
function place(scope) {
(scope || document).querySelectorAll('.single-product-wrap').forEach(function (card) {
if (card.dataset.tpsCard === '1') return;
card.dataset.tpsCard = '1';
var label = card.querySelector('.product-image > .product-label');
if (label && !label.querySelector('.card-discount-badge')) {
var badge = card.querySelector('.price-box .card-discount-badge');
if (badge) label.appendChild(badge.cloneNode(true));
}
rebuildRating(card);
var bar = card.querySelector('.product-image .bottom-action');
if (bar) card.appendChild(bar);
});
}
function watch() {
var grid = document.querySelector('[id*="collection-template"], .product-grid-list');
if (!grid || !window.MutationObserver) return;
var queued = false;
new MutationObserver(function () {
if (queued) return;
queued = true;
requestAnimationFrame(function () { queued = false; place(grid); });
}).observe(grid, { childList: true, subtree: true });
}
function boot() { place(); watch(); }
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
document.addEventListener('shopify:section:load', function (e) { place(e.target); });
window.addEventListener('load', function () { place(); });
})();
/* tapsara-category-row

   16 Sep 2026 — the tile ladder mirrors the "Shop by Solution Area" grid
   exactly, because the two rows sit above and below each other and were
   disagreeing on tablets: at 768-989px this row showed FIVE 144px tiles with
   30px gaps while Solution Area showed THREE 219px tiles with 18px gaps.

     >= 1200px   5 tiles, 30px gap
     >=  990px   4 tiles, 20px gap
     >=  750px   3 tiles, 18px gap
     <   750px   CSS scroll row, Swiper destroyed (see tapsara.css)

   BOTH of the following have to agree or the tiles come out the wrong width:
     1. the data-view-* attributes, which the THEME's own CSS reads to set the
        slide width (data-view-md governs 750-989px, data-view-lg 990-1199px)
     2. Swiper's per-breakpoint slidesPerView / spaceBetween params
*/
(function () {
var PHONE = '(max-width: 749px)';
function perView(bp) {
var n = parseInt(bp, 10) || 0;
if (n >= 1199) return 5;
if (n >= 990) return 4;
if (n >= 750) return 3;
return 2;
}
function gapFor(bp) {
var n = parseInt(bp, 10) || 0;
if (n >= 1199) return 30;
if (n >= 990) return 20;
if (n >= 750) return 18;
return 15;
}
function tune(section) {
var el = section.querySelector('.swiper');
if (!el) return;
if (window.matchMedia(PHONE).matches) {
section.classList.add('tps-cat-row');
if (el.swiper) {
try { el.swiper.destroy(true, true); } catch (e) {}
}
return;
}
el.setAttribute('data-view', '5');
el.setAttribute('data-view-lg', '4');
el.setAttribute('data-view-md', '3');
el.setAttribute('data-view-sm', '2');
var sw = el.swiper;
if (!sw || !sw.params || !sw.params.breakpoints) return;
Object.keys(sw.params.breakpoints).forEach(function (bp) {
var b = sw.params.breakpoints[bp];
if (!b) return;
b.slidesPerView = perView(bp);
b.slidesPerGroup = perView(bp);
b.spaceBetween = gapFor(bp);
});
try {
sw.currentBreakpoint = null;
sw.setBreakpoint();
sw.update();
} catch (e) {}
}
function tidy(text) {
if (text !== text.toUpperCase()) return text;
return text.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
}
function label(section) {
section.querySelectorAll('.collection-card').forEach(function (card) {
var name = card.querySelector('[class*="__text_cw"]');
if (!name) return;
var target = name.querySelector('p') || name;
var text = (target.textContent || '').trim();
if (!text) return;
var nice = tidy(text);
if (nice !== text) target.textContent = nice;
card.querySelectorAll('a.group-block__link > .v-hidden').forEach(function (s) {
s.textContent = nice;
});
});
}
function run() {
document.querySelectorAll('[id*="collection_list"]').forEach(function (section) {
if (!section.querySelector('.collection-card')) return;
label(section);
tune(section);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', run);
} else {
run();
}
window.addEventListener('load', run);
document.addEventListener('shopify:section:load', run);
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(run, 250);
});
})();
/* tapsara-solution-area */
(function () {
var OLD = 'banner_multirow_q8f6bV';
function place() {
var me = document.querySelector('.tps-sa');
if (!me || me.dataset.tpsPlaced === '1') return;
var old = document.querySelector('[id*="' + OLD + '"]');
if (!old) return;
old.style.display = 'none';
old.setAttribute('data-tps-replaced-by', 'solution-area');
old.parentNode.insertBefore(me, old);
me.hidden = false;
me.dataset.tpsPlaced = '1';
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', place);
} else {
place();
}
document.addEventListener('shopify:section:load', place);
})();
/* tapsara-reviews-carousel — gutter sync

   Copies the horizontal padding off the theme's own .container-fluid onto the
   Judge.me widget as --tps-gutter, which assets/tapsara.css uses to inset the
   review row. That is why the reviews line up with "Shop by Solution Area" on
   the exact same pixel at every screen width — the value is READ from the
   theme rather than guessed.

   A ResizeObserver on that reference element drives it, not a window resize
   listener: it fires whenever the element's own box changes, so it also covers
   page zoom, phone rotation and the theme reflowing for any other reason.

   Judge.me injects its widget asynchronously, so this also polls briefly until
   the widget appears, then stops. Nothing breaks if it never appears or if
   .container-fluid is missing: the CSS falls back to a 15px inset.
*/
(function () {
function ref() {
return document.querySelector('.container-fluid') || document.querySelector('.container');
}
function sync() {
var widgets = document.querySelectorAll('.jdgm-cards-carousel');
if (!widgets.length) return false;
var r = ref();
if (!r) return true;
var g = getComputedStyle(r).paddingLeft;
for (var i = 0; i < widgets.length; i++) {
widgets[i].style.setProperty('--tps-gutter', g);
}
return true;
}
var observing = false;
function observe() {
if (observing || !window.ResizeObserver) return;
var r = ref();
if (!r) return;
observing = true;
new ResizeObserver(function () { sync(); }).observe(r);
}
function boot() { sync(); observe(); }
var tries = 0;
var poll = setInterval(function () {
observe();
if (sync() || ++tries > 40) clearInterval(poll);
}, 400);
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
window.addEventListener('load', boot);
document.addEventListener('shopify:section:load', boot);
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(sync, 200);
});
})();
/* tapsara-seo — Read more / Show less, for BOTH expandable SEO blocks.

   17 Sep 2026: this used to be two copies of the same script — one for the
   home page block, one printed inline into every collection page by
   sections/collection-seo-content.liquid. It is now one function that wires up
   every element carrying data-tps-seo.

   Behaviour, unchanged from both originals:
     - collapses to the height set by --tps-seo-collapsed
     - animates open to the measured scrollHeight, so the transition has a real
       end value instead of 'auto', which cannot be animated
     - hides the whole toggle if the copy is short enough not to need it
     - on collapse, scrolls the block back into view if its top has gone above
       the viewport, so the page does not jump to the footer
     - re-measures on resize, because the collapsed copy reflows at every width

   The labels are toggled by BOTH the hidden attribute and an inline display,
   because the theme's own CSS sets display on spans and beats [hidden].
*/
(function () {
function wire(root) {
if (root.dataset.tpsSeoReady === '1') return;
var body = root.querySelector('[data-tps-seo-body]');
var wrap = root.querySelector('[data-tps-seo-toggle-wrap]');
var toggle = root.querySelector('[data-tps-seo-toggle]');
var more = root.querySelector('[data-tps-seo-label-more]');
var less = root.querySelector('[data-tps-seo-label-less]');
var fade = root.querySelector('[data-tps-seo-fade]');
if (!body || !wrap || !toggle || !more || !less) return;
root.dataset.tpsSeoReady = '1';
function setLabels(expanded) {
more.hidden = expanded;
less.hidden = !expanded;
more.style.display = expanded ? 'none' : '';
less.style.display = expanded ? '' : 'none';
}
function checkOverflow() {
if (toggle.getAttribute('aria-expanded') === 'true') return;
var collapsed = parseInt(getComputedStyle(body).getPropertyValue('--tps-seo-collapsed'), 10) || 150;
var needed = body.scrollHeight > collapsed + 20;
wrap.style.display = needed ? '' : 'none';
if (fade) fade.style.display = needed ? '' : 'none';
if (!needed) body.style.maxHeight = 'none';
}
toggle.addEventListener('click', function () {
var expanded = toggle.getAttribute('aria-expanded') === 'true';
body.style.setProperty('--tps-seo-expanded', body.scrollHeight + 'px');
if (!expanded) {
body.classList.add('is-expanded');
toggle.setAttribute('aria-expanded', 'true');
setLabels(true);
} else {
void body.offsetHeight;
body.classList.remove('is-expanded');
toggle.setAttribute('aria-expanded', 'false');
setLabels(false);
if (root.getBoundingClientRect().top < 0) {
root.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
}
});
setLabels(false);
checkOverflow();
root.tpsSeoCheck = checkOverflow;
}
function run(scope) {
(scope || document).querySelectorAll('[data-tps-seo]').forEach(wire);
}
function recheck() {
document.querySelectorAll('[data-tps-seo]').forEach(function (r) {
if (typeof r.tpsSeoCheck === 'function') r.tpsSeoCheck();
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { run(); });
} else {
run();
}
window.addEventListener('load', function () { run(); recheck(); });
document.addEventListener('shopify:section:load', function (e) { run(e.target); });
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(recheck, 200);
});
})();
/* tapsara-gift-guard — 21 Sep 2026.

   Removes any line of the free gift variant that a customer added themselves.

   WHY. snippets/free-gift-bar.liquid adds the free gift with a hidden line
   property, _always_gift, and every decision it makes reads that property.
   But the gift is a real ₹0 product that also appears in search and on
   collection pages with a working Add to cart. A line added that way has no
   property, so the gift script counts it as a PAYING item: it stays, and a
   second free one is added on top. Measured 21 Sep — two tapes, total ₹0,
   ready to check out.

   WHAT THIS DOES. After every cart change it looks at the cart, not the page,
   and removes gift-variant lines that are missing the property. The script's
   own gift is never touched. Other variants of the same product are untouched
   too — this matches the one gift variant id, which
   snippets/tapsara-gift-guard.liquid reads from the same theme setting the
   gift script reads.

   LIMIT, stated plainly: this is browser-side, like the gift feature itself.
   It closes every normal route — search, collections, quick add, a shared
   cart link. Someone who turns JavaScript off entirely could still post a ₹0
   line to the cart. Closing that needs the server-side fix: give the gift a
   real price and zero it with an automatic discount.

   TO REMOVE: delete the tapsara-gift-guard render line in
   snippets/fullscreen-bg.liquid. This block then does nothing, because
   window.TPS_GIFT_VARIANT is never set.
*/
(function () {
var ID = window.TPS_GIFT_VARIANT;
if (!ID) return;
var busy = false;
var timer = null;
function applySections(sections) {
if (!sections) return;
if (sections['cart-drawer']) {
var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
var fresh = doc.querySelector('#CartDrawer');
var live = document.getElementById('CartDrawer');
if (fresh && live) live.innerHTML = fresh.innerHTML;
}
if (sections['ajax-cart-icon']) {
var doc2 = new DOMParser().parseFromString(sections['ajax-cart-icon'], 'text/html');
var fresh2 = doc2.querySelector('.shopify-section');
var live2 = document.getElementById('ajax-cart-icon');
if (fresh2 && live2) live2.innerHTML = fresh2.innerHTML;
}
}
function sweep() {
if (busy) return;
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
var strays = [];
cart.items.forEach(function (item) {
var props = item.properties || {};
var isGift = Object.prototype.hasOwnProperty.call(props, '_always_gift');
if (item.variant_id === ID && !isGift) strays.push(item.key);
});
if (!strays.length) return;
busy = true;
var updates = {};
strays.forEach(function (k) { updates[k] = 0; });
return fetch('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ updates: updates, sections: 'cart-drawer,ajax-cart-icon' }),
__tpsGiftInternal: true
}).then(function (r) { return r.json(); }).then(function (result) {
busy = false;
applySections(result && result.sections);
}).catch(function () { busy = false; });
}).catch(function () {});
}
function schedule() {
clearTimeout(timer);
timer = setTimeout(sweep, 400);
}
function isCartEndpoint(url) {
return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
}
var nativeFetch = window.fetch;
if (nativeFetch) {
window.fetch = function (input, init) {
var url = (typeof input === 'string') ? input : (input && input.url);
var mine = init && init.__tpsGiftInternal;
var hit = !mine && isCartEndpoint(url);
var result = nativeFetch.apply(this, arguments);
if (hit) result.then(schedule, schedule);
return result;
};
}
var nativeSend = XMLHttpRequest.prototype.send;
var nativeOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url) {
this.__tpsGiftCartCall = isCartEndpoint(url);
return nativeOpen.apply(this, arguments);
};
XMLHttpRequest.prototype.send = function () {
if (this.__tpsGiftCartCall) this.addEventListener('loadend', schedule);
return nativeSend.apply(this, arguments);
};
document.addEventListener('cart:updated', schedule);
document.addEventListener('cart:refresh', schedule);
setTimeout(sweep, 1200);
})();
/* tapsara-cart-drawer — 21 Sep 2026. Cart line layout + upsell ADD picker.

   PART 1 — CART LINE LAYOUT

   1. THE PRICE MOVES UP. The theme renders the drawer line as
        .item-title-row  (title + remove button)
        .item-price      (struck price, and the price actually charged)
        .item-option
        .mini-cart-qty-box
      four blocks stacked vertically. The design wants the price with the
      title. They are siblings, not parent and child, so no stylesheet can put
      one inside the other: the price element is moved into the title row,
      which then wraps (see tapsara-cart-drawer in assets/tapsara.css).

   2. THE "SAVE %" PILL. Nothing in the markup carries the discount, so it is
      worked out from the two prices already on the line.

      "Rs." ENDS IN A DOT, AND THAT IS WHAT BROKE IT. The first two versions
      deleted every character that was not a digit or a dot. The dot in "Rs."
      survives that, so it became the decimal point:

          "Rs. 999.00"    ->   ".99900"    ->   parseFloat  0.999
          "Rs. 1,299.00"  ->   ".129900"   ->   parseFloat  0.1299

      Both prices came back as fractions, and (0.999 - 0.1299) / 0.999 is 87%
      — a plausible-looking number on every single line, which is how it
      survived two rounds of checking. Measured 21 Sep: a ₹999 line against
      ₹1,299 should read 23% and read 87%.

      amountOf now READS the number instead of deleting characters around it:
      strip the thousands commas, then take the last run that looks like a
      number. "Rs." contributes no digits, so it cannot take part.

      READ EVERY PRICE SPAN, NOT TWO NAMED ONES. The drawer does not use one
      markup shape. Some lines render .price-item-sale / .price-item-regular
      and others a bare <span> / .old-price. Looking for only the first pair
      produced no pill at all on the second shape.

      Free gift lines are skipped: they carry their own FREE / 100% Off.

   3. DRAWER ONLY. Both of the above are applied inside .ajax-cart and nowhere
      else. The /cart page uses the same class names but is styled entirely by
      the theme, and the CSS here is scoped to the drawer — so touching its
      markup would have moved a price into a row with nothing to style it.
      Measured 21 Sep: the unscoped version was reaching that page.

   PART 2 — "YOU MIGHT ALSO LIKE" GETS AN ADD BUTTON

   The upsell cards in the drawer are image + title + price and nothing else:
   no add button, and — unlike the cards on a collection page — no
   <quick-add-modal> rendered for them either. A shopper who wanted one had to
   leave the drawer, losing the cart they were about to check out with.

   So this adds an ADD button to each card, and a picker that opens on top of
   the drawer: image, title, price, one row of choices per option, a quantity
   stepper, and add to cart. It is built from the product's own JSON at
   /products/<handle>.js, so it always matches what is really in stock.

   The drawer's HTML is replaced wholesale by Shopify section rendering after
   every cart change, so a MutationObserver re-applies everything to the fresh
   markup. Its callback is debounced and every step is a no-op once applied.

   PART 3 — THE EMPTY-STATE CLASS (13 Oct 2026). See the file header. The
   drawer's empty/filled state is a class on the <cart-drawer> ELEMENT, which
   is the PARENT of #CartDrawer — and every refresh path in this theme
   replaces only #CartDrawer.innerHTML, so that class is never updated. Add
   something to an empty cart and the items arrive in the DOM underneath a
   stale is-empty, which the theme's CSS uses to hide the item list AND the
   footer holding the checkout button.

   syncEmpty() below re-derives the class from the markup — are there any
   .cart-item nodes — and is called from apply(), so it runs on the same
   observer every other drawer fix already uses, whichever script did the
   re-render. It restores the theme's own class instead of overriding the
   theme's CSS, so it does not need to know what that CSS hides.
*/
(function () {
var MONEY = function (paise) {
var n = (paise || 0) / 100;
try {
return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
} catch (e) {
return 'Rs. ' + n.toFixed(2);
}
};

function amountOf(text) {
var m = (text || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/g);
if (!m || !m.length) return NaN;
return parseFloat(m[m.length - 1]);
}

function isBadge(el) {
var c = (el.className || '').toString();
return /tps-cart-off|free-gift-off-badge|free-gift-free-label|card-discount-badge/.test(c);
}

function addPill(item) {
var price = item.querySelector('.item-price');
if (!price) return;
if (price.querySelector('.tps-cart-off')) return;
if (item.classList.contains('is-free-gift')) return;
if (item.querySelector('.free-gift-off-badge')) return;
var nums = [].slice.call(price.children)
.filter(function (el) { return !isBadge(el); })
.map(function (el) { return amountOf(el.textContent); })
.filter(function (n) { return !isNaN(n) && n > 0; });
if (nums.length < 2) return;
var hi = Math.max.apply(null, nums);
var lo = Math.min.apply(null, nums);
if (hi <= lo) return;
var off = Math.round(((hi - lo) / hi) * 100);
if (off < 1 || off > 99) return;
var pill = document.createElement('span');
pill.className = 'tps-cart-off';
pill.textContent = 'SAVE ' + off + '%';
price.appendChild(pill);
}

function layoutLines(root) {
if (!root) return;
root.querySelectorAll('.cart-item').forEach(function (item) {
var row = item.querySelector('.item-title-row');
var price = item.querySelector('.item-price');
if (row && price && !row.contains(price)) {
var remove = row.querySelector('cart-remove-button');
if (remove) row.insertBefore(price, remove);
else row.appendChild(price);
}
addPill(item);
});
}

/* See PART 3 in the block comment above. */
function syncEmpty(root) {
if (!root) return;
var host = root.closest ? root.closest('cart-drawer') : null;
if (!host) return;
var hasItems = !!root.querySelector('.cart-item');
host.classList.toggle('is-empty', !hasItems);
}

function applySections(sections) {
if (!sections) return;
if (sections['cart-drawer']) {
var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
var fresh = doc.querySelector('#CartDrawer');
var live = document.getElementById('CartDrawer');
if (fresh && live) live.innerHTML = fresh.innerHTML;
}
if (sections['ajax-cart-icon']) {
var doc2 = new DOMParser().parseFromString(sections['ajax-cart-icon'], 'text/html');
var fresh2 = doc2.querySelector('.shopify-section');
var live2 = document.getElementById('ajax-cart-icon');
if (fresh2 && live2) live2.innerHTML = fresh2.innerHTML;
}
}

var cache = {};
var picker = null;

function handleOf(card) {
var a = card.querySelector('a[href*="/products/"]');
if (!a) return null;
var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
return m ? m[1] : null;
}

function addButtons(root) {
if (!root) return;
root.querySelectorAll('.product-slider .single-product-wrap').forEach(function (card) {
if (card.querySelector('.tps-up-add')) return;
var handle = handleOf(card);
if (!handle) return;
var btn = document.createElement('button');
btn.type = 'button';
btn.className = 'tps-up-add';
btn.textContent = '+ ADD';
btn.setAttribute('aria-label', 'Add this product');
btn.addEventListener('click', function (e) {
e.preventDefault();
e.stopPropagation();
openPicker(handle, btn);
});
var content = card.querySelector('.product-content') || card;
content.appendChild(btn);
});
}

function openPicker(handle, btn) {
if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
var done = function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } };
if (cache[handle]) { build(cache[handle]); done(); return; }
fetch('/products/' + handle + '.js')
.then(function (r) { return r.json(); })
.then(function (p) { cache[handle] = p; build(p); done(); })
.catch(function () { done(); window.location.href = '/products/' + handle; });
}

function closePicker() {
if (!picker) return;
document.documentElement.classList.remove('tps-qv-lock');
var el = picker.overlay;
picker = null;
if (el && el.parentNode) el.parentNode.removeChild(el);
}

function build(product) {
closePicker();

var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
var values = names.map(function (_, i) {
var seen = [];
product.variants.forEach(function (v) {
var val = (v.options || [])[i];
if (val && seen.indexOf(val) === -1) seen.push(val);
});
return seen;
});
var single = product.variants.length === 1 || names.length === 0;
var chosen = (product.variants.filter(function (v) { return v.available; })[0] || product.variants[0]).options.slice();
var qty = 1;

var overlay = document.createElement('div');
overlay.className = 'tps-qv-overlay';
overlay.innerHTML =
'<div class="tps-qv" role="dialog" aria-modal="true" aria-label="Add to cart">' +
'<button type="button" class="tps-qv__close" aria-label="Close">' +
'<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
'</button>' +
'<div class="tps-qv__top">' +
'<div class="tps-qv__img"></div>' +
'<div class="tps-qv__head">' +
'<p class="tps-qv__title"></p>' +
'<p class="tps-qv__price"><span class="tps-qv__now"></span><span class="tps-qv__was"></span></p>' +
'</div>' +
'</div>' +
'<div class="tps-qv__opts"></div>' +
'<div class="tps-qv__qty">' +
'<span class="tps-qv__optname">Quantity</span>' +
'<div class="tps-qv__stepper">' +
'<button type="button" data-step="-1" aria-label="Decrease">&minus;</button>' +
'<span class="tps-qv__qtyval">1</span>' +
'<button type="button" data-step="1" aria-label="Increase">+</button>' +
'</div>' +
'</div>' +
'<button type="button" class="tps-qv__add">ADD TO CART</button>' +
'</div>';
document.body.appendChild(overlay);

var imgWrap = overlay.querySelector('.tps-qv__img');
var addBtn = overlay.querySelector('.tps-qv__add');
var optsWrap = overlay.querySelector('.tps-qv__opts');
var qtyVal = overlay.querySelector('.tps-qv__qtyval');

overlay.querySelector('.tps-qv__title').textContent = product.title;
if (product.featured_image) {
var img = document.createElement('img');
img.src = product.featured_image;
img.alt = '';
img.loading = 'lazy';
imgWrap.appendChild(img);
}

function current() {
for (var i = 0; i < product.variants.length; i++) {
var v = product.variants[i];
var ok = true;
for (var j = 0; j < chosen.length; j++) {
if ((v.options || [])[j] !== chosen[j]) { ok = false; break; }
}
if (ok) return v;
}
return null;
}

function existsWith(index, value) {
return product.variants.some(function (v) {
if (!v.available) return false;
if ((v.options || [])[index] !== value) return false;
for (var j = 0; j < chosen.length; j++) {
if (j !== index && (v.options || [])[j] !== chosen[j]) return false;
}
return true;
});
}

function renderOptions() {
optsWrap.innerHTML = '';
if (single) return;
names.forEach(function (name, i) {
var block = document.createElement('div');
block.className = 'tps-qv__opt';
var label = document.createElement('p');
label.className = 'tps-qv__optname';
label.innerHTML = name + ': <span></span>';
label.querySelector('span').textContent = chosen[i] || '';
block.appendChild(label);
var row = document.createElement('div');
row.className = 'tps-qv__choices';
values[i].forEach(function (val) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'tps-qv__choice';
b.textContent = val;
if (val === chosen[i]) b.classList.add('is-on');
if (!existsWith(i, val)) b.classList.add('is-off');
b.addEventListener('click', function () {
chosen[i] = val;
renderOptions();
renderPrice();
});
row.appendChild(b);
});
block.appendChild(row);
optsWrap.appendChild(block);
});
}

function renderPrice() {
var v = current();
var now = overlay.querySelector('.tps-qv__now');
var was = overlay.querySelector('.tps-qv__was');
if (!v) {
now.textContent = '';
was.textContent = '';
addBtn.textContent = 'UNAVAILABLE';
addBtn.disabled = true;
return;
}
now.textContent = MONEY(v.price);
if (v.compare_at_price && v.compare_at_price > v.price) {
was.textContent = MONEY(v.compare_at_price);
was.style.display = '';
} else {
was.textContent = '';
was.style.display = 'none';
}
addBtn.disabled = !v.available;
addBtn.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
}

overlay.querySelectorAll('.tps-qv__stepper button').forEach(function (b) {
b.addEventListener('click', function () {
qty = Math.max(1, qty + parseInt(b.getAttribute('data-step'), 10));
qtyVal.textContent = qty;
});
});

addBtn.addEventListener('click', function () {
var v = current();
if (!v || !v.available) return;
addBtn.disabled = true;
addBtn.textContent = 'ADDING...';
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ items: [{ id: v.id, quantity: qty }], sections: 'cart-drawer,ajax-cart-icon' })
}).then(function (r) { return r.json(); }).then(function (res) {
applySections(res && res.sections);
apply();
document.dispatchEvent(new CustomEvent('cart:updated'));
closePicker();
}).catch(function () {
addBtn.disabled = false;
addBtn.textContent = 'ADD TO CART';
});
});

overlay.querySelector('.tps-qv__close').addEventListener('click', closePicker);
overlay.addEventListener('click', function (e) { if (e.target === overlay) closePicker(); });
document.addEventListener('keydown', function esc(e) {
if (e.key === 'Escape') { closePicker(); document.removeEventListener('keydown', esc); }
});

picker = { overlay: overlay };
renderOptions();
renderPrice();
document.documentElement.classList.add('tps-qv-lock');
}

function drawer() {
return document.getElementById('CartDrawer') || document.querySelector('.ajax-cart');
}

function apply() {
var d = drawer();
if (!d) return;
layoutLines(d);
addButtons(d);
syncEmpty(d);
}

function boot() {
var d = drawer();
apply();
if (!d || !window.MutationObserver || d.tpsCartObserved) return;
d.tpsCartObserved = true;
var queued = false;
new MutationObserver(function () {
if (queued) return;
queued = true;
setTimeout(function () { queued = false; apply(); }, 60);
}).observe(d, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
window.addEventListener('load', boot);
document.addEventListener('cart:updated', apply);
})();
/* tapsara-cart-slider — 21 Sep 2026. The "You might also like" carousel.

   THE ARROWS DID NOT WORK. Measured 21 Sep with two products in the row:

       slides: 2      slidesPerView: 1      width: 522      slideW: 522
       isEnd: true    arrow-next-drawer has class swiper-button-disabled

   Two slides, one visible, and Swiper believed it was already on the last
   one — so it disabled the next arrow and refused to move. The cause is the
   drawer: every cart change replaces the drawer's whole HTML through Shopify
   section rendering, and the theme re-initialises Swiper on the new markup
   while its measurements still describe the old one. Swiper has a method for
   exactly this — update() — and nothing was calling it.

   THE MARK LIVES ON THE SWIPER INSTANCE, NOT THE ELEMENT. An earlier version
   stamped the element and never looked at it again, but the theme re-inits
   Swiper on that SAME element after a cart change — a new instance on an
   element already marked done, so it kept the stale measurements and the
   dead arrow. That is why it worked in a scripted test and not for a person.

   THE ARROWS ARE NOT ALWAYS SWIPER'S. If the theme's markup does not match
   the navigation selectors Swiper was given, the arrows are inert DOM that no
   amount of update() will wake. A delegated capture-phase click handler on
   the drawer drives slidePrev / slideNext directly, so they work either way.
   It is bound once and is idempotent.

   REWIND, SO IT KEEPS GOING. With update() alone the carousel stopped dead on
   the last slide: autoplay advanced and then had nowhere to go. rewind makes
   the slide after the last one the first again. NOT loop: loop clones every
   slide, and these cards carry an ADD button wired to a specific product, so
   cloned buttons would be wired twice.

   IT ALSO SCROLLS BY ITSELF. The theme already asks for autoplay, but
   autoplay cannot advance a carousel that believes it is at the end, so it
   never ran. 3500ms, resumes after interaction, holds still on hover.
*/
(function () {
function drawerEl() {
return document.getElementById('CartDrawer') || document.querySelector('.ajax-cart');
}
function sliderEl() {
var d = drawerEl();
return d ? d.querySelector('.drawer-slider') : null;
}
function swiperOf() {
var el = sliderEl();
return el && el.swiper ? el.swiper : null;
}

function fix(attempt) {
var el = sliderEl();
if (!el) return;
var sw = el.swiper;
if (!sw) {
if ((attempt || 0) < 10) setTimeout(function () { fix((attempt || 0) + 1); }, 300);
return;
}
if (sw.tpsFixed) return;
sw.tpsFixed = true;
try {
if (!sw.params.loop) sw.params.rewind = true;
sw.allowTouchMove = true;
sw.update();
if (sw.navigation && sw.navigation.update) sw.navigation.update();
} catch (e) {}
try {
if (sw.autoplay && sw.slides && sw.slides.length > 1) {
sw.params.autoplay = sw.params.autoplay || {};
sw.params.autoplay.delay = 3500;
sw.params.autoplay.disableOnInteraction = false;
sw.params.autoplay.pauseOnMouseEnter = true;
sw.autoplay.start();
}
} catch (e) {}
}

function wireArrows(drawer) {
if (drawer.tpsArrows) return;
drawer.tpsArrows = true;
drawer.addEventListener('click', function (e) {
var t = e.target && e.target.closest ? e.target.closest('[class*="arrow-"],.swiper-button-next,.swiper-button-prev') : null;
if (!t || !drawer.contains(t)) return;
var sw = swiperOf();
if (!sw) return;
var cls = (t.className || '').toString();
var isPrev = /prev/i.test(cls);
var isNext = /next/i.test(cls);
if (!isPrev && !isNext) return;
e.preventDefault();
e.stopPropagation();
try {
sw.update();
if (isPrev) { sw.slidePrev(); } else { sw.slideNext(); }
if (sw.navigation && sw.navigation.update) sw.navigation.update();
} catch (err) {}
}, true);
}

function boot() {
fix(0);
var drawer = drawerEl();
if (!drawer) return;
wireArrows(drawer);
if (!window.MutationObserver || drawer.tpsSliderObserved) return;
drawer.tpsSliderObserved = true;
var queued = false;
new MutationObserver(function () {
if (queued) return;
queued = true;
setTimeout(function () { queued = false; fix(0); }, 120);
}).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', boot);
} else {
boot();
}
window.addEventListener('load', boot);
document.addEventListener('cart:updated', function () { fix(0); });
})();
